<template>
    <Chat
        :participants="computedParticipants"
        :myself="computeMyself"
        :messages="messages"
        :chat-title="chatTitle"
        :placeholder="placeholder"
        :colors="colors"
        :border-style="borderStyle"
        :hide-close-button="hideCloseButton"
        :close-button-icon-size="closeButtonIconSize"
        :submit-icon-size="submitIconSize"
        :submit-image-icon-size="submitImageIconSize"
        :load-more-messages="toLoad.length > 0 ? loadMoreMessages : null"
        :async-mode="asyncMode"
        :scroll-bottom="scrollBottom"
        :display-header="false"
        :send-images="false"
        :profile-picture-config="profilePictureConfig"
        :timestamp-config="timestampConfig"
        :link-options="linkOptions"
        :accept-image-types="'.png, .jpeg'"
        @onImageClicked="onImageClicked"
        @onImageSelected="onImageSelected"
        @onMessageSubmit="onMessageSubmit"
        @onType="onType"/>
</template>

<script>
import {Chat} from 'vue-quick-chat';
import {mapGetters, mapState} from 'vuex';
import MediaManager from "@/api/MediaManager";

export default {
    components: {
        Chat
    },
    data() {
        return {
            publicPath: process.env.BASE_URL,

            lastTimeMessageCheck: undefined,
            noMessagesYet: true,
            chatMessage: null,
            participantIDMap:  new Map(),
            participantsIDCounter: 0,
            participants: [
                /*
                {
                    name: 'Arnaldo',
                    id: 1,
                    profilePicture: 'https://upload.wikimedia.org/wikipedia/en/thumb/a/a1/NafSadh_Profile.jpg/768px-NafSadh_Profile.jpg'
                },
                {
                    name: 'José',
                    id: 2,
                    profilePicture: 'https://lh3.googleusercontent.com/-G1d4-a7d_TY/AAAAAAAAAAI/AAAAAAAAAAA/AAKWJJPez_wX5UCJztzEUeCxOd7HBK7-jA.CMID/s83-c/photo.jpg'
                }
            */
            ],
            cachedParticipants: [],
            myself: {
                name: 'Myself',
                id: 3,
                profilePicture: 'https://lh3.googleusercontent.com/-G1d4-a7d_TY/AAAAAAAAAAI/AAAAAAAAAAA/AAKWJJPez_wX5UCJztzEUeCxOd7HBK7-jA.CMID/s83-c/photo.jpg'
            },
            /*
            messages: [
                {
                    content: 'received messages',
                    myself: false,
                    participantId: 1,
                    timestamp: {year: 2019, month: 3, day: 5, hour: 20, minute: 10, second: 3, millisecond: 123},
                    type: 'text'
                },
            ],
            */
            chatTitle: 'My chat title',
            placeholder: this.$i18n.t('Ihre Nachricht eingeben...'),
            colors: {
                header: {
                    bg: '#d30303',
                    text: '#fff'
                },
                message: {
                    myself: {
                        bg: '#fff',
                        text: '#bdb8b8'
                    },
                    others: {
                        bg: '#fff',
                        text: '#bdb8b8'
                                             },
                    messagesDisplay: {
                        bg: '#f7f3f3'
                    }
                },
                submitIcon: '#bdb8b8',
                submitImageIcon: '#E76101',
            },
            borderStyle: {
                topLeft: "10px",
                topRight: "10px",
                bottomLeft: "10px",
                bottomRight: "10px",
            },
            hideCloseButton: false,
            submitIconSize: 25,
            submitImageIconSize: 25,
            closeButtonIconSize: "20px",
            asyncMode: false,
            toLoad: [
                /*
                {
                    content: 'Hey, John Doe! How are you today?',
                    myself: false,
                    participantId: 2,
                    timestamp: {year: 2011, month: 3, day: 5, hour: 10, minute: 10, second: 3, millisecond: 123},
                    uploaded: true,
                    viewed: true,
                    type: 'text'
                },
                {
                    content: "Hey, Adam! I'm feeling really fine this evening.",
                    myself: true,
                    participantId: 3,
                    timestamp: {year: 2010, month: 0, day: 5, hour: 19, minute: 10, second: 3, millisecond: 123},
                    uploaded: true,
                    viewed: true,
                    type: 'text'
                },
                */
            ],
            scrollBottom: {
                messageSent: true,
                messageReceived: true
            },
            displayHeader:true,
            profilePictureConfig: {
                others: true,
                myself: true,
                styles: {
                    width: '30px',
                    height: '30px',
                    borderRadius: '50%'
                }
            },
            timestampConfig: {   
                format: 'HH:mm',
                relative: false
            },
            // there are other options, you can check them here
            // https://soapbox.github.io/linkifyjs/docs/options.html
            linkOptions: {
                myself: {
                    className: 'myLinkClass',
                    events: {
                        
                        //click: function (e) {
                             // var win = window.open(e, '_blank');
                             // win.focus();
                         //   alert('Link clicked!'+JSON.stringify(e));
                        //},
                        //mouseover: function (e) {
                         //   alert('Link hovered!'+e);
                        //}
                    },
                    format: function (value, type) {
                        if (type === 'url' && value.length > 50) {
                            value = value.slice(0, 50) + '…';
                        }
                        return value;
                    }
                },
                others: {
                    className: 'othersLinkClass',
                    events: {
                        /*
                        click: function (e) {
                            alert('Link clicked!' +e );
                        },
                        mouseover: function (e) {
                            alert('Link hovered!'+e);
                        }
                        */
                    },
                    format: function (value, type) {
                        if (type === 'url' && value.length > 50) {
                            value = value.slice(0, 50) + '…';
                        }
                        return value;
                    }
                }
            }
        }
    },
    methods: {
        onType: function (event) {
            //here you can set any behavior
            // console.log("Event:" +event);
        },
        loadMoreMessages(resolve) {
            setTimeout(() => {
                resolve(this.toLoad); //We end the loading state and add the messages
                //Make sure the loaded messages are also added to our local messages copy or they will be lost
                this.messages.unshift(...this.toLoad);
                this.toLoad = [];
            }, 1000);
        },
        onMessageSubmit: function (message) {
            if (message) {
				this.$store.dispatch('broadcastChatMessage', message.content);
            } 
			this.chatMessage = null;
            /*
            * you can update message state after the server response
            */
            // timeout simulating the request
            setTimeout(() => {
                message.uploaded = true
            }, 2000)
        },
        onImageSelected(files, message){
            let src = 'https://149364066.v2.pressablecdn.com/wp-content/uploads/2017/03/vue.jpg'
            this.messages.push(message);
            /**
             * This timeout simulates a requisition that uploads the image file to the server.
             * It's up to you implement the request and deal with the response in order to
             * update the message status and the message URL
             */
            setTimeout((res) => {
                message.uploaded = true
                message.src = res.src
            }, 3000, {src});
        },
        onImageClicked(message){
            /**
             * This is the callback function that is going to be executed when some image is clicked.
             * You can add your code here to do whatever you need with the image clicked. A common situation is to display the image clicked in full screen.
             */
            console.log('Image clicked', message.src)
        },
        mapFluxID2ParticipantID( fluxID ) {
            if( fluxID === this.localUserID )
                return 1;
            let participant = this.cachedParticipants.find( x => x.fluxID === fluxID );
            if( participant ) {
                return participant.id;
            }
            return 1;
        },
        registerID(realID, id){
            this.participantIDMap.set(realID, id);
        },
         nextParticipantsID(){
            this.participantsIDCounter = this.participantsIDCounter + 1;
            return this.participantsIDCounter;
        },
    },

    computed: {
        ...mapGetters(["mediaURL","users", "localUserID", "localUser", "commands"], ),
        ...mapState({
			currentChatRoom: (state) => state.session.currentChatRoom,
			signalController: (state) => state.session.signalController,
        }),
        messages(state){
            if(state.signalController && state.signalController.getDelegate("chat") && state.signalController.getDelegate("chat").chatMessages){
                let messagesAdapted = state.signalController.getDelegate("chat").chatMessages.map(x => {
                    let date = new Date(x.timestamp);
                    
                    return {
                        content: x.message, 
                        participantId: this.mapFluxID2ParticipantID(x.userId), 
                        type: 'text',
                        timestamp: {year: date.getUTCFullYear(), month: date.getMonth()+1, day: date.getUTCDate(), hour: date.getHours(), minute: date.getMinutes(), second: date.getSeconds(), millisecond: date.getMilliseconds()},
                        myself: x.userId === this.localUserID
                    };
                });

                messagesAdapted.forEach(message => {
                    if(this.lastTimeMessageCheck){
                        let millisecondsMessage = message.timestamp.minute * 60 + message.timestamp.second;
                        let millisecondsLastCheck = this.lastTimeMessageCheck.minute * 60 + this.lastTimeMessageCheck.second;
                        if(millisecondsMessage > millisecondsLastCheck && !message.myself){
                            let audio = new Audio(this.publicPath + "/media"+this.mediaURL+"/newMessage.mp3");
                            audio.play();
                        }
                    }
                });

                let date = new Date();
                this.lastTimeMessageCheck = {year: date.getUTCFullYear(), month: date.getMonth(), day: date.getUTCDate(), hour: date.getHours(), minute: date.getMinutes(), second: date.getSeconds(), millisecond: date.getMilliseconds()};

                return messagesAdapted;
            }
            else
                return [];
        },
        computedParticipants(){
            let participants = this.cachedParticipants;
            this.users.forEach(user => {
                // Check if we have to add an participant...
                let cached = this.cachedParticipants.find( x => x.fluxID == user.getID() );
                if( !cached ) {
                    // Adding new participant!
                    let p ={};
                    p.name = user.getName();
                    p.fluxID = user.getID();
                    if(user.getUserIcon())
                        p.profilePicture = user.getUserIcon();
                    else{
                       p.profilePicture = MediaManager.getUserAvatar(user);  
                    }
                    p.id = this.cachedParticipants.length + 2; // 1 is myself
                    //this.registerID(p.realID, p.id);    
                    this.cachedParticipants.push(p);
                }
            });
            return participants;
        },
        computeMyself(){
            console.log("QuickChat - computeMyself");
     
            let p = {};
            p.name = "XXXX";
            p.id = 1;
          
           // p.profilePicture= 'https://lh3.googleusercontent.com/-G1d4-a7d_TY/AAAAAAAAAAI/AAAAAAAAAAA/AAKWJJPez_wX5UCJztzEUeCxOd7HBK7-jA.CMID/s83-c/photo.jpg';
            let user = this.users.filter( x => x.getID() == this.localUserID);
            if( user && user.length > 0 ){
                p.name = user[0].getName();
                p.fluxID = user[0].getID();
                 if(user[0].getUserIcon()){
                     console.log("UserIcon is set" + user[0].getUserIcon());
                        p.profilePicture = user[0].getUserIcon();
                       //  p.profilePicture = MediaManager.getUserAvatar(user[0]);  
                    }
                    else{
                        console.log("Getting UserAvatar from MediaManager!!");
                       p.profilePicture = MediaManager.getUserAvatar(user[0]);  
                    }
                }
            return p;     
        },
        currentCommands: function() {
            return this.commands;
        },
    },
    mounted() {
        oncontextmenu = function () {
            if(document.getElementsByClassName("context-menu").length > 1){
                for(let a = 0; a < document.getElementsByClassName("context-menu").length - 1; a++){
                    document.getElementsByClassName("context-menu")[a].remove();
                }
            }
            return false;
        };

        window.addEventListener("click", function () {
            if(document.getElementsByClassName("context-menu").length > 0){
                for(let a = 0; a < document.getElementsByClassName("context-menu").length; a++){
                document.getElementsByClassName("context-menu")[a].remove();
                }
            }
        });
    },
    watch: {
        messages: function (newValue) {
            if(this.localUser && this.localUser.getRole() === "moderator") {
                const self = this;
                setTimeout(function () {
                    let messageContainer = document.getElementsByClassName("message-container")[newValue.length - 1];
                    if(messageContainer) {
                        messageContainer.addEventListener("contextmenu", function (event) {
                            const contextMenu = document.createElement("div");
                            contextMenu.classList.add("context-menu");
                            contextMenu.style.left = "" + (event.clientX - 200) + "px";
                            contextMenu.style.top = "" + event.clientY + "px";

                            const contextMenuEntry = document.createElement("div");
                            contextMenuEntry.classList.add("context-menu-entry");
                            contextMenuEntry.innerText = "Nachricht löschen";
                            contextMenuEntry.addEventListener("click", function () {
                                self.$store.dispatch('deleteMessage', self.messages[newValue.length - 1]);
                                self.$store.commit("deleteChatMessage", newValue.length - 1);
                                //self.messages.splice(newValue.length - 1, 1);
                                if (document.getElementsByClassName("context-menu").length > 0) {
                                    for (let a = 0; a < document.getElementsByClassName("context-menu").length; a++) {
                                        document.getElementsByClassName("context-menu")[a].remove();
                                    }
                                }
                            })
                            contextMenu.appendChild(contextMenuEntry);
                            document.getElementsByTagName("body")[0].appendChild(contextMenu);
                        })
                    }   
                }, 1000);
            }
        },
        currentCommands: function (newValue) {
            const self = this;
            if( newValue ) {
                newValue.filter( c => !c.isCompleted() ).forEach( command => {
                    if(command.getType() === "DeleteMessage") {
                        let index = -1;

                        for(let a = 0; a < self.messages.length; a++){
                            if(self.messages[a].timestamp === command.message.timestamp){
                                index = a;
                                break;
                            }
                        }
                        if(index !== -1){
                            console.log("Delete message with timestamp: " + self.messages[index].timestamp);
                            self.messages.splice(index, 1);
                            self.$store.commit("deleteChatMessage", index);
                            command.setCompleted();
                        }else{
                            console.log("No message with that timestamp found.");
                        }
                    }
                })
            }
        },
    }
}
</script>

<style>
.quick-chat-container .header-container{
    height:70px;
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
 /* padding:0 20px 0 10px;*/
    -webkit-box-align:center;
    -ms-flex-align:center;
    align-items:center;
    -webkit-box-shadow:0 2px 20px 2px rgba(90,90,90,.47);
    box-shadow:0 2px 20px 2px rgba(90,90,90,.47);
    z-index:5;  
    }
    
.quick-chat-container .header-container .header-title{
    padding:10px;
    -webkit-box-flex:1;
    -ms-flex:1;
    flex:1;
    text-align:left;
    z-index:5
    }
  
.quick-chat-container .header-container .header-title-text{
    margin-bottom:0;

    }
.quick-chat-container .header-container .header-paticipants-text{
    color:#e4e4e4;
    font-size:12px;
    margin-top:5px;
    max-height:30px;
    overflow:hidden
}
.quick-chat-container .header-container .header-exit-button{
    text-decoration:none;
    color:#fff;
    font-size:20px
}
.quick-chat-container .header-container .icon-close-chat{
    color:#fff;
    width:100%
}
.quick-chat-container .header-container .icon-close-chat:hover{
    color:#ee7979
}
.container-message-display .myself-message-body{
   /* padding-right:10px; */
    -webkit-box-pack:end;
    -ms-flex-pack:end;
    justify-content:flex-end;
    margin-left:10px;
    margin-right:10px;
}
.container-message-display .myself-message-body,.container-message-display .myself-message-body .message-content{
   /* display:-webkit-box;
    display:-ms-flexbox;
    display:flex;*/
    display: -webkit-flex;
    -webkit-flex-wrap: wrap;
    display: flex;   
    flex-wrap: wrap;


    -webkit-box-align:end; 
    -ms-flex-align:end;
    align-items:flex-end
}.container-message-display .myself-message-body .message-content{
    -webkit-box-pack:start;
    -ms-flex-pack:start;
    justify-content:flex-start;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
    -ms-flex-direction:column;
    flex-direction:column;
    -webkit-box-flex:1;
    -ms-flex-positive:1;
    flex-grow:1;
    margin-right:10px
}
.container-message-display .myself-message-body .participant-thumb{
    width:25px;
    height:25px;
    border-radius:50%;
    margin-left:10px
}
.container-message-display .myself-message-body .message-timestamp{
    padding:2px 7px;
    border-radius:15px;
    margin:0;
    max-width:50%;
    overflow-wrap:break-word;
    text-align:left;
    font-size:10px;
    color:#bdb8b8;
    width:100%;
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-align:center;
    -ms-flex-align:center;
    align-items:center
}
.container-message-display .myself-message-body .message-text{
    background:#fff;
    padding:6px 10px;
    line-height:14px;
    border-radius:15px;
    margin:10px;
    margin:5px 0 5px 0;
    max-width:70%;
    overflow-wrap:break-word;
    text-align:left;
    white-space:pre-wrap;
    border-bottom-right-radius:0;
    word-break:break-word;
    min-width:100px;
    max-width: 250px;
    
}
.container-message-display .other-message-body{
  /*  display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    */
     display: -webkit-flex;
    -webkit-flex-wrap: wrap;
    display: flex;   
    flex-wrap: wrap;


    -webkit-box-align:end;
    -ms-flex-align:end;
    align-items:flex-end;
    margin-left:10px;
}
.container-message-display .other-message-body .message-content{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-align:start;
    -ms-flex-align:start;
    align-items:flex-start;
    -webkit-box-pack:start;
    -ms-flex-pack:start;
    justify-content:flex-start;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
    -ms-flex-direction:column;
    flex-direction:column;
    -webkit-box-flex:1;
    -ms-flex-positive:1;
    flex-grow:1
}
.container-message-display .other-message-body .participant-thumb{
    margin-right:10px
}
.container-message-display .other-message-body .message-timestamp{
    padding:2px 7px;
    border-radius:15px;
    margin:0;
    max-width:50%;
    overflow-wrap:break-word;
    text-align:left;
    font-size:10px;
    color:#bdb8b8;
    width:100%;
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-align:center;
    -ms-flex-align:center;
    align-items:center
}
.container-message-display .other-message-body .message-text{
    background:#fff;
    padding:6px 10px;
    line-height:14px;
    border-radius:15px;
    margin:5px 0 5px 0;
    max-width:70%;
    overflow-wrap:break-word;
    text-align:left;
    white-space:pre-wrap;
    border-bottom-left-radius:0;
    word-break:break-word;
    min-width: 100px;
    max-width: 250px;
    }

.quick-chat-container .container-message-display{
    -webkit-box-flex:1;
    -ms-flex:1;flex:1;
    overflow-y:auto;
    overflow-x:hidden;
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
    -ms-flex-direction:column;
    flex-direction:column;
    padding-bottom:10px;
    max-height:100%
}
    @media not all and (min-resolution:0.001dpcm){@supports (-webkit-appearance:none)
    {.quick-chat-container .container-message-display .message-container{display:-webkit-box!important}}}
    .quick-chat-container .container-message-display .message-image{
        padding:6px 10px;
        border-radius:0px;
        margin:5px 0 5px 0;
        max-width:70%;
        position:relative;
        display:-webkit-box;
        display:-ms-flexbox;
        display:flex;
        -webkit-box-align:center;
        -ms-flex-align:center;
        align-items:center;
        -webkit-box-pack:center;
        -ms-flex-pack:center;
        justify-content:center
    }
.quick-chat-container .container-message-display .message-image-display{
    width:100%;
    border-radius:5px;
    cursor:pointer;
    -webkit-transition:.3s ease;
    transition:.3s ease
}
.quick-chat-container .container-message-display .message-image-display:hover{
    opacity:.8
}
.quick-chat-container .container-message-display .message-text>p{
    margin:5px 0 5px 0;
    font-size:14px;
     color: rgb(20, 20, 20);
}
.quick-chat-container .container-message-display .my-message>.message-timestamp{
    text-align:right
}
.quick-chat-container .container-message-display .other-message{
    -webkit-box-pack:start;
    -ms-flex-pack:start;
    justify-content:flex-start;
    padding-left:15px;
    -webkit-box-align:start;
    -ms-flex-align:start;
    align-items:flex-start
}
.quick-chat-container .container-message-display .other-message>.message-text{
    color:#fff;
    border-bottom-left-radius:0
}
.quick-chat-container .container-message-display .my-message>.message-text{
    border-bottom-right-radius:0
}
.quick-chat-container .container-message-display .message-container{
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -ms-flex-wrap:wrap;
    flex-wrap:wrap;
    -webkit-box-orient:vertical;
    -webkit-box-direction:normal;
    -ms-flex-direction:column;
    flex-direction:column
}
.quick-chat-container .container-message-display .message-username{
    font-size:10px;
    font-weight:900;
    color: black;
}
.quick-chat-container .container-message-display .icon-sent{
    padding-left:5px;
    color:#817f7f
}
.quick-chat-container .container-message-display .message-loading{
    height:8px;
    width:8px;
    border:1px solid #bbb7b7;
    border-left-color:#3b3b3b;
    border-radius:50%;
    margin-left:5px;
    display:inline-block;
    -webkit-animation:spin 1.3s ease infinite;
    animation:spin 1.3s ease infinite
}
.quick-chat-container .container-message-display .loader .message-loading{
    width:16px;
    height:16px;
    margin:5px 0 0 0
}
.quick-chat-container .container-message-display .img-loading{
    height:20px;
    width:20px;
    border:3px solid hsla(0,0%,100%,0);
    border-left-color:#847f7f;
    border-top-color:#847f7f;
    border-radius:50%;
    margin-left:5px;
    display:inline-block;
    -webkit-animation:spin 1s ease infinite;
    animation:spin 1s ease infinite;
    position:absolute
}
.quick-chat-container .container-message-display .img-overlay{
    opacity:.4
}
.quick-chat-container .container-message-display .message-username-image{
    margin:10px 10px 0 10px;
    font-size:12px;
    font-weight:700}@-webkit-keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}

.quick-chat-container {
  height: calc(35vh - 48px);
  width:100%;
  background:#f0eeee;
  display:flex;
  display:-webkit-box;
  display:-ms-flexbox;
  /* -webkit-box-shadow:0 -2px 40px 0 hsla(0,0%,72.9%,.67);
  box-shadow:0 -2px 40px 0 hsla(0,0%,72.9%,.67); */
  -webkit-box-orient:vertical;
  -webkit-box-direction:normal;
  -ms-flex-direction:column;
  flex-direction:column;
  -webkit-box-align:stretch;
  -ms-flex-align:stretch;
  align-items:stretch;
  overflow:hidden
}

.container-message-manager{
    height:65px;background:#fff;
    display:-webkit-box;
    display:-ms-flexbox;
    display:flex;
    -webkit-box-align:center;
    -ms-flex-align:center;
    align-items:center;
    padding:0 20px 0 20px;
    -webkit-box-shadow:0 -2px 40px 0 rgba(186, 186, 186, 0.3);
    box-shadow:0 -2px 40px 0 hsla(0,0%,72.9%,.3)
}


.quick-chat-container .container-message-manager .message-text-box{
    padding:0 10px 0 10px;
    -webkit-box-flex:1;
    -ms-flex:1;
    flex:1;
    overflow:hidden
}
.quick-chat-container .container-message-manager .message-input{
    width:100%;
    resize:none;
    border:none;
    outline:none;
    -webkit-box-sizing:border-box;
    box-sizing:border-box;
    font-size:15px;
    font-weight:400;
    line-height:1.33;
    white-space:pre-wrap;
    word-wrap:break-word;
    color:#565867;
    -webkit-font-smoothing:antialiased;
    max-height:40px;
    bottom:0;
    overflow:scroll;
    overflow-x:hidden;
    overflow-y:auto;
    text-align:left;
    cursor:text;
    display:inline-block
}
.quick-chat-container .container-message-manager .message-input:empty:before{
    content:attr(placeholder);
    display:block;
    -webkit-filter:contrast(15%);
    filter:contrast(15%);
    outline:none
}
.quick-chat-container .container-message-manager .message-input:focus{
    outline:none
}
.quick-chat-container .container-message-manager .container-send-message{
    margin-left:10px
}
.quick-chat-container .container-message-manager .container-send-message svg{
    -webkit-box-sizing:content-box;
    box-sizing:content-box

}
.quick-chat-container .container-message-manager .icon-send-message{
    cursor:pointer;
    opacity:.7;
    -webkit-transition:.3s;
    transition:.3s;
    border-radius:11px;
    padding:6px;  
}
.quick-chat-container .container-message-manager .icon-send-message:hover{
    opacity:1;
}

.material-design-icon > .material-design-icon__svg {
    fill: "#E76101";
}
.container-message-display::-webkit-scrollbar{
    width: 12px;
}
.container-message-display::-webkit-scrollbar-track{
    background: rgba(185, 185, 185,0.5);
    border-radius: 10%;
}
.container-message-display::-webkit-scrollbar-thumb{
    border-radius:10px;
    background: rgb(255, 255, 255);
    border: 1px solid rgba(153, 103, 103,0.4);
}
.context-menu{
  position: absolute;
  width: 200px;
  background-color: white;
  border: solid 1px black;
  border-radius: 2px;
  z-index: 100;
}
.context-menu-entry{
  display: flex;
  align-items: center;
  height: 30px;
  padding-left: 5px;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.context-menu-entry:hover{
  color: white;
}
.quick-chat-container .material-design-icon>.material-design-icon__svg {
    fill: var(--primaryColor);
}
/*MOBILE*/
@media (max-device-width: 900px){
  .container-message-manager{
    height:20%;
    min-height: 50px;
    margin-bottom: 28px;
  }
}


</style>
